// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * A `BACnet` point description from the `bacnet_points` table.
 */
export class BacnetPoint implements flatbuffers.IUnpackableObject<BacnetPointT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): BacnetPoint {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsBacnetPoint(bb: flatbuffers.ByteBuffer, obj?: BacnetPoint): BacnetPoint {
    return (obj || new BacnetPoint()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsBacnetPoint(
    bb: flatbuffers.ByteBuffer,
    obj?: BacnetPoint,
  ): BacnetPoint {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new BacnetPoint()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  adapterId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  groupName(): string;
  groupName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  groupName(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  pointName(): string;
  pointName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  pointName(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  groupId(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  hostId(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  pointId(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startBacnetPoint(builder: flatbuffers.Builder) {
    builder.startObject(10);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addAdapterId(builder: flatbuffers.Builder, adapterIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, adapterIdOffset, 0);
  }

  static addGroupName(builder: flatbuffers.Builder, groupNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, groupNameOffset, 0);
  }

  static addPointName(builder: flatbuffers.Builder, pointNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, pointNameOffset, 0);
  }

  static addGroupId(builder: flatbuffers.Builder, groupId: number) {
    builder.addFieldInt32(4, groupId, 0);
  }

  static addHostId(builder: flatbuffers.Builder, hostId: number) {
    builder.addFieldInt32(5, hostId, 0);
  }

  static addPointId(builder: flatbuffers.Builder, pointId: number) {
    builder.addFieldInt32(6, pointId, 0);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, deletedAtOffset, 0);
  }

  static endBacnetPoint(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // id
    builder.requiredField(offset, 6); // adapter_id
    builder.requiredField(offset, 8); // group_name
    builder.requiredField(offset, 10); // point_name
    return offset;
  }

  unpack(): BacnetPointT {
    return new BacnetPointT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.adapterId() !== null ? this.adapterId()!.unpack() : null,
      this.groupName(),
      this.pointName(),
      this.groupId(),
      this.hostId(),
      this.pointId(),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
    );
  }

  unpackTo(_o: BacnetPointT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.adapterId = this.adapterId() !== null ? this.adapterId()!.unpack() : null;
    _o.groupName = this.groupName();
    _o.pointName = this.pointName();
    _o.groupId = this.groupId();
    _o.hostId = this.hostId();
    _o.pointId = this.pointId();
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
  }

  unpackFields(...fields: string[]): BacnetPointT {
    const t = new BacnetPointT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("adapter_id")) {
      t.adapterId = this.adapterId() !== null ? this.adapterId()!.unpack() : null;
    }
    if (fieldSet.has("group_name")) {
      t.groupName = this.groupName();
    }
    if (fieldSet.has("point_name")) {
      t.pointName = this.pointName();
    }
    if (fieldSet.has("group_id")) {
      t.groupId = this.groupId();
    }
    if (fieldSet.has("host_id")) {
      t.hostId = this.hostId();
    }
    if (fieldSet.has("point_id")) {
      t.pointId = this.pointId();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    return t;
  }
}

export class BacnetPointT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public adapterId: UuidT | null = null,
    public groupName: string | Uint8Array | null = null,
    public pointName: string | Uint8Array | null = null,
    public groupId: number = 0,
    public hostId: number = 0,
    public pointId: number = 0,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.id === null || this.id === undefined) {
      throw new Error('Required field "id" is not set');
    }
    if (this.adapterId === null || this.adapterId === undefined) {
      throw new Error('Required field "adapter_id" is not set');
    }
    if (this.groupName === null || this.groupName === undefined) {
      throw new Error('Required field "group_name" is not set');
    }
    if (this.pointName === null || this.pointName === undefined) {
      throw new Error('Required field "point_name" is not set');
    }
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const adapterId = this.adapterId !== null ? this.adapterId!.pack(builder) : 0;
    const groupName = this.groupName !== null ? builder.createString(this.groupName!) : 0;
    const pointName = this.pointName !== null ? builder.createString(this.pointName!) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;

    BacnetPoint.startBacnetPoint(builder);
    BacnetPoint.addId(builder, id);
    BacnetPoint.addAdapterId(builder, adapterId);
    BacnetPoint.addGroupName(builder, groupName);
    BacnetPoint.addPointName(builder, pointName);
    BacnetPoint.addGroupId(builder, this.groupId);
    BacnetPoint.addHostId(builder, this.hostId);
    BacnetPoint.addPointId(builder, this.pointId);
    BacnetPoint.addCreatedAt(builder, createdAt);
    BacnetPoint.addUpdatedAt(builder, updatedAt);
    BacnetPoint.addDeletedAt(builder, deletedAt);

    return BacnetPoint.endBacnetPoint(builder);
  }

  clone(): BacnetPointT {
    const obj = new BacnetPointT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.adapterId = this.adapterId !== null ? this.adapterId!.clone() : null;
    obj.groupName = this.groupName;
    obj.pointName = this.pointName;
    obj.groupId = this.groupId;
    obj.hostId = this.hostId;
    obj.pointId = this.pointId;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    return obj;
  }

  equals(other: BacnetPointT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.adapterId !== null && other.adapterId !== null) {
      if (!this.adapterId!.equals(other.adapterId!)) return false;
    } else if (this.adapterId !== other.adapterId) return false;
    if (this.groupName !== other.groupName) return false;
    if (this.pointName !== other.pointName) return false;
    if (this.groupId !== other.groupId) return false;
    if (this.hostId !== other.hostId) return false;
    if (this.pointId !== other.pointId) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    return true;
  }
}

export function verifyBacnetPoint(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "adapter_id");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 8, "group_name");
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 10, "point_name");
    verifier.checkScalarField(tablePos, 12, 4);
    verifier.checkScalarField(tablePos, 14, 4);
    verifier.checkScalarField(tablePos, 16, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 22);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
